import { initAppLang } from "./app";
import { initApiLang } from "./api";

const cs = new Map<string, string>();

initAppLang(cs);
initApiLang(cs);

export { cs };
